export default __webpack_public_path__ + "static/media/fountain.5f14eae6.png";